import React from "react";

function WidgetButtonsWrapper({ children }) {
    return <div className="widgetsBtn">{children}</div>;
}

export default WidgetButtonsWrapper;
